import React, { useEffect } from 'react'
import Slider from './Slider'

import Footer from './Footer/Footeer'
import { HomedataProvider } from '../Admin/Homedata/HomedataProvider'
import DianamicLoading from '../assets/Loading/DianamicLoading'
import AutocompleteWithRefine from './Search/AutoComplete/AutoComplete'
import Grid from './grid/Grid'
import Scroll from './scroll/scroll'
import Product from './Catgories/Row1'
import Mostoderd from './Catgories/Row3'
import Bestratedbestprice from './Catgories/Row2'
export default function Home() {
  useEffect(() => {
    localStorage.setItem("searchTerm", "");
  },[])

  return (
    <div className='bg-white' >
    <DianamicLoading/>
      <HomedataProvider>
      <div className='px-4 md:hidden block py-6'>
      <AutocompleteWithRefine />
      </div>
    
      {/* <Banner /> */}
     
        <Grid />
         <Scroll/>
                <Slider />
        <Product />
        <Bestratedbestprice />
        <Mostoderd />
        <Footer />
      </HomedataProvider>
    </div>
  );
}
